import {Colors} from 'mgUiKit';

export default function getTheme(type) {

    if(type == undefined || type != "dark"){
        type = "light";
    }
    var theme = {
        type: type,
        primaryColor: Colors.white,
        backgroundColorTheme: Colors.grey100,
        //backgroundColorTheme2: Colors.grey300
        backgroundColorTheme2: Colors.white,
        color: Colors.grey600,
        color2: Colors.grey600,


    };

    if(type == 'dark'){
        theme.backgroundColorTheme = Colors.grey900;
        theme.backgroundColorTheme2 =  Colors.grey800;
        theme.color =  Colors.white;
        theme.color2 =  Colors.white;
        
    }    
    return theme;
}